import { createAction, props } from '@ngrx/store';

import { PicEntity } from '../domain/pic.entity';

export enum PicActions {
	FetchPicsForProjectSuccess = '[BE][Project][Pics] Fetch pics for project success',
	FetchPicsForProjectFail = '[BE][Project][Pics] Fetch pics for project fail',
}

export const fetchPicsForProjectSuccess = createAction(
	PicActions.FetchPicsForProjectSuccess,
	props<{ pics: Array<PicEntity> }>()
);

export const fetchPicsForProjectFail = createAction(
	PicActions.FetchPicsForProjectFail,
	props<{ error: unknown }>()
);
